<div class="flex" style="margin-top: 15px;" *ngIf="devices && devices.length > 0 && !loadingDevices">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [value]="devices"
        [totalRecords]="totalDevices"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="serialNumber">
              {{'attribute.serialNumber' | transloco}}<p-sortIcon field="serialNumber"></p-sortIcon></th>
            <th pSortableColumn="description">
              {{'attribute.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="deviceCategory.name">
              {{'model.deviceCategory' | transloco}}<p-sortIcon field="deviceCategory.name"></p-sortIcon></th>
            <th pSortableColumn="tenant.name">
              {{'model.tenant' | transloco}}<p-sortIcon field="tenant.name"></p-sortIcon></th>
            <th pSortableColumn="organization.name">
              {{'model.organization' | transloco}}<p-sortIcon field="organization.name"></p-sortIcon></th>
            <th pSortableColumn="dateLastValueReported">
              {{'attribute.dateLastValueReported' | transloco}}<p-sortIcon field="dateLastValueReported"></p-sortIcon></th>
            <th pSortableColumn="associationDate">
              {{'attribute.associationDate' | transloco}}<p-sortIcon field="associationDate"></p-sortIcon></th>
            <th pSortableColumn="associationEndDate">
              {{'attribute.associationEndDate' | transloco}}<p-sortIcon field="associationEndDate"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-device>
          <tr *ngIf="!loadingDevices">
            <td>
              <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
              <a [routerLink]="'/devices/' + device.uuid + '/details'">{{device.serialNumber}}</a>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
              {{device.description}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
              {{device.deviceCategory ? device.deviceCategory.name : ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
              {{device.tenant ? device.tenant.name : ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
              {{device.organization ? device.organization.name : ''}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
              {{device.dateLastValueReported | customDate}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.associationDate' | transloco}}</span>
              {{device.associationDate | customDate}}
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.associationEndDate' | transloco}}</span>
              {{device.associationEndDate | customDate}}
            </td>
          </tr>
          <tr *ngIf="loadingDevices">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalDevices == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalDevices > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalDevices ? totalDevices : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalDevices}}
            {{(totalDevices > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="devices && devices.length == 0">
  <div class="card w-full">
    <p class="text-xl text-center p-6 font-italic">{{'empty.devices' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!devices || loadingDevices">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>
